export const HTTP_HEADER_KEYS = {
  CONTENT_TYPE: 'Content-Type',
};

export const HTTP_CONTENT_TYPES = {
  OCTET_STREAM: 'application/octet-stream',
};